import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const ProfitDashboard = () => {
  return <DashboardPageTemplate pageName={"profit"} showCogsWarning={true} />;
};
